import React from 'react';

const About = () => {
    return (
        <div>
            <h1>Welcome to about page</h1>
        </div>
    );
};

export default About;